export default __webpack_public_path__ + "static/media/resale_construction_equipment_online.ae74c047.png";